import { useEffect } from "react";

export function useElements(props) {
  const {
    fabDropdown,
    setAllElementAnchorEl,
    setAutoOpen,
    setWindowDimensions,
    contentGroup,
    experienceGroup,
    isOverlapping,
    setIsOverlapping,
    setWidthAdjustment,
    windowDimensions,
    singleElementView,
  } = props;

  useEffect(() => {
    if (!fabDropdown) {
      setAllElementAnchorEl(null);
      setAutoOpen(false);
    }
  }, [fabDropdown]);

  useEffect(() => {
    const getWindowDimensions = () => {
      const { innerWidth: width, innerHeight: height } = window;
      return { width, height };
    };
    setWindowDimensions(getWindowDimensions());

    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const doesOverlap = (rect1, rect2) => {
      return !(
        rect1.top > rect2.bottom ||
        rect1.right < rect2.left ||
        rect1.bottom < rect2.top ||
        rect1.left > rect2.right
      );
    };
    if (contentGroup && experienceGroup) {
      const overlap = doesOverlap(contentGroup, experienceGroup);

      if (overlap && !isOverlapping) {
        setIsOverlapping(overlap);
        setWidthAdjustment(windowDimensions.width);
      }

      if (singleElementView && !overlap) {
        // separate elements if not overlapping
        setIsOverlapping(false);
        setAllElementAnchorEl(null);
        setAutoOpen(false);
      }
    }
  }, [contentGroup, experienceGroup, windowDimensions.width]);
}
